var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaxCategoryMaster(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 21a.75.75 0 0 1-.75.75H6A2.752 2.752 0 0 1 3.25 19v-8.16c0-1.392.606-2.708 1.663-3.61l4.839-4.149c1.25-1.071 3.246-1.071 4.496 0l4.84 4.15c.491.428.871.909 1.133 1.435a.75.75 0 1 1-1.342.67 3.19 3.19 0 0 0-.772-.97L13.272 4.22c-.707-.605-1.836-.606-2.543 0l-4.84 4.149A3.24 3.24 0 0 0 4.75 10.84V19c0 .689.561 1.25 1.25 1.25h2a.75.75 0 0 1 .75.75zm11.78-9.53a.75.75 0 0 0-1.061 0l-9 9a.75.75 0 0 0 1.06 1.061l9-9a.75.75 0 0 0 0-1.061zm-8.03-.22c1.24 0 2.25 1.009 2.25 2.25s-1.01 2.25-2.25 2.25-2.25-1.009-2.25-2.25 1.01-2.25 2.25-2.25zm0 1.5a.75.75 0 0 0 0 1.5.75.75 0 0 0 0-1.5zm8.25 6.75c0 1.241-1.01 2.25-2.25 2.25s-2.25-1.009-2.25-2.25 1.01-2.25 2.25-2.25 2.25 1.009 2.25 2.25zm-1.5 0a.75.75 0 0 0-1.5 0 .75.75 0 0 0 1.5 0z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxCategoryMaster);
export default __webpack_public_path__ + "static/media/tax-category-master.2eaa9daf3e886d9f66fa1a8247da9eea.svg";
export { ForwardRef as ReactComponent };